import styled from 'styled-components'

const ListStyle = styled.section`
	--cocktailsItemDistance: var(--sp10x);

	margin-top: var(--subSectionDistance);

	.load-more-btn-wrap {
		margin-top: var(--cocktailsItemDistance);
		display: flex;
		justify-content: center;
	}

	.cocktail-item {
		&:nth-child(3n + 0),
		&:nth-child(3n + 1) {
			margin-top: var(--cocktailsItemDistance);
		}

		.cc-item {
			transform: translate3d(0, 150%, 0);
		}

		.image-cont {
			border-radius: 60%;
		}
	}

	.cocktails-content-wrap {
		overflow: hidden;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		--cocktailsItemDistance: var(--sp10x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		--cocktailsItemDistance: var(--sp10x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--cocktailsItemDistance: var(--sp8x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--cocktailsItemDistance: var(--sp7x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--cocktailsItemDistance: var(--sp7x);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--cocktailsItemDistance: var(--sp6x);

		.cocktail-item {
			&:nth-child(3n + 0),
			&:nth-child(3n + 1) {
				margin-top: 0;
			}

			&:nth-child(2n) {
				margin-top: var(--cocktailsItemDistance);
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--cocktailsItemDistance: var(--sp4x);

		.cocktail-item {
			&:nth-child(3n + 0),
			&:nth-child(3n + 1) {
				margin-top: 0;
			}

			&:nth-child(n + 2) {
				margin-top: var(--cocktailsItemDistance);
			}
		}
	}
`

export default ListStyle
